module.exports = __webpack_public_path__ + "img/shared_briefcase_icon.524abca6.png";